import { Preferences } from "../../profile/objects/preferences";
import { PURCHASE_MODULE } from "../constant/purchaseConstant";
import { Column } from "../objects/column";

export const setPurchasePreference = (new_preferences: Preferences[], state_columns: Column[]): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '-created_date';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.map((preference: Preferences) => {
        if (preference.module === PURCHASE_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'NAME':
                        columns.push({ label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'name' : order_by;
                        break;
                    case 'IBAN':
                        columns.push({ label: 'iban', field_name: preference.field_name, checked: preference.active, order_by: 'iban', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'iban' : order_by;
                        break;
                    case 'BIC':
                        columns.push({ label: 'bic', field_name: preference.field_name, checked: preference.active, order_by: 'bic', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'bic' : order_by;
                        break;
                    case 'IS_COMMISSION_APPLIED':
                        columns.push({ label: 'is-commission-applied', field_name: preference.field_name, checked: preference.active, order_by: 'is_commission_applied', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'is_commission_applied' : order_by;
                        break;
                    case 'COMMISSION_PERCENTAGE':
                        columns.push({ label: 'commission-percentage', field_name: preference.field_name, checked: preference.active, order_by: 'commission_percentage', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'commission_percentage' : order_by;
                        break;
                    case 'CREATED_DATE':
                        columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'created_date' : order_by;
                        break;
                    case 'CREATED_BY':
                        columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'creator__username' : order_by;
                        break;
                    case 'MODIFIED_DATE':
                        columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'modified_date' : order_by;
                        break;
                    case 'MODIFIED_BY':
                        columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'last_author__username' : order_by;
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { order_by, order, columns, preferences };
};